/* global swal angular */

import './style.less';

export default function($q, $log, $stateParams, $state, Swal, ApiClass, ProfileClass) {
  'ngInject';
  const vm = this;

  vm.loaded = true;
}



// WEBPACK FOOTER //
// ./src/app/components/admin/eventManager/event/addons/controller.js